module.exports = __webpack_public_path__ + "img/073628.77212b42.png";